export const activityCentresEndpoint = 'activity-centres';
export const assetsManagerEndpoint = 'https://assets-manager.services.kidiup.com/v1/';
export const activityCategoriesEndpoint = 'activity-categories';
export const localEndpoint = 'http://127.0.0.1:6060/v1';
export const assetsEndpoint = 'https://assets.kidiup.com';
export const usersEndpoint = "users";
export const userSessionsEndpoint = "user-sessions";
export const notificationsEndpoint = "notifications";
export const reportingEndpoint = "reporting";
